<template>
    <div class="col backgroundForm">
        <h3 clas="col" align="center">{{ title }}</h3>
        
        <nav class="nav nav-pills nav-justified" id="nav-tab" role="tablist">
            
                <a class="nav-item nav-link active" id="nav-init-traffic" data-toggle="tab" href="#nav-init" role="tab" aria-controls="nav-home" aria-selected="true">1. Nuevo</a>
                <a class="nav-item nav-link" id="nav-second-traffic" data-toggle="tab" href="#nav-second" role="tab" aria-controls="nav-profile" aria-selected="false" >2. Baja</a>
        
        </nav>

          <div class="tab-content" id="nav-tabContent">
                <br>            
                <div class="tab-pane fade show active"  id="nav-init" role="tabpanel" aria-labelledby="nav-home-tab">
                
                <div class="row">
                    <div class="col-12 col-sm-6">               
                        <div class="col">

                            <div class="col">
                                <div class="form-group">
                                    <label for="recipient-name" class="col-form-label">Capitania de Puerto</label>
                                    <select name="" id="" class="form-control" v-model="port_select" v-if="cSessionUser.roleAssign !== 'OPERADOR CAPITANIA'">
                                        <option v-for="pt in ports" :key="pt.id" :value="pt">{{ pt.name_port }}</option>
                                    </select>
                                    <input type="text" class="form-control-plaintext" v-else :value="cSessionUser.name_port">
                                </div>
                            </div>
                        </div>
                        <div class="form-group col">
                            <label for="title">Titulo</label>
                            <input type="text" name="title_photo" id="title_photo" class="form-control" autocomplete="off" v-model="detail_photo.title">
                        </div>

                        <div class="form-group col">
                            <label for="title">Descripcion</label>
                            <textarea name="description_photo" class="form-control" id="" cols="30" rows="5" autocomplete="off" v-model="detail_photo.description"></textarea>
                        </div>
                        
                    </div>
                    <div align="center" class="col-12 col-sm-6" id="imageShip">
                        <image-uploader
                        :preview="true"
                        :className="['fileinput' ,{ 'fileinput--loaded': hasImage }]"
                        capture="environment"
                        :debug="1"
                        doNotResize="gif"
                        :scaleRatio="scaleImage"
                        :quality="qualityImage"
                        :autoRotate="true"
                        outputFormat="verbose"
                        @input="setImage"
                    >
                    
                        <label for="fileInput" slot="upload-label" class="col">
                        <div><font-awesome-icon icon="camera-retro" size="3x"></font-awesome-icon></div>
                        <span class="upload-caption">{{
                            hasImage ? "Cambiar" : "Seleccionar Foto"
                        }}</span>
                        </label>
                        </image-uploader>
                    </div>
                </div>       
                <div align="center">
                    <transition name="fade">
                    <button class="btn btn-outline-primary" @click="sendPhotoShip" v-if="btnUp">Subir <font-awesome-icon icon="upload" ></font-awesome-icon></button>
                    </transition>
                </div>
            </div>
            <!-- end first tab -->

            <div class="tab-pane fade show"  id="nav-second" role="tabpanel" aria-labelledby="nav-home-tab">
                
                <div class="form-group col-md-4 offset-md-4">
                    <label for="recipient-name" class="col-form-label">Capitania de Puerto</label>
                    <select name="" id="" class="form-control" v-model="port_low_select" @change="mChangeCaptain" v-if="cSessionUser.roleAssign !== 'OPERADOR CAPITANIA'">
                        <option v-for="pt in ports" :key="pt.id" :value="pt">{{ pt.name_port }}</option>
                    </select>
                    <input type="text" class="form-control-plaintext" v-else :value="cSessionUser.name_port">
                </div>

                <div align="center">
                    <transition name="fade">
                    <button class="btn btn-outline-primary" @click="mGetPhotos">Listar <font-awesome-icon icon="list" ></font-awesome-icon></button>
                    </transition>
                </div>

                <!-- aca mostramos las fotos de la capitania -->
                <br>
                <div class="col-12 col-md-4 offset-md-4" v-if="bImages.length > 0">
                    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel" data-interval="0" >
                        <div class="carousel-inner">

                            <div class="carousel-item" v-for="(icap,key) in bImages " :key="icap.id_photo" :class=" {'active': (key===0) }">
                                <img class="d-block w-100 img-responsive" :src="icap.path" alt="First slide">
                                <div class="carousel-caption d-none d-md-block">
                                    <h5>{{ icap.title }}</h5>
                                    <p><button class="btn btn-danger" @click="mLowPhoto(icap)"><font-awesome-icon icon="arrow-circle-down" ></font-awesome-icon> Baja</button></p>
                                </div>
                            </div>
                            
                        </div>
                        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>

                </div>

            </div>
            <!-- end second tab -->

            <div class="tab-pane fade show"  id="nav-tirdh" role="tabpanel" aria-labelledby="nav-home-tab">
                <h2>Eliminacion de Fotos</h2>
            </div>

        </div>    

    <modal-loading :id-modal="idModalL" :title="modalLoadTitle" :status-send="sendRequest" ></modal-loading>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';

import modalLoading from '../modal/modalLoading';

const qs= require('qs');

export default {
    name:'upload-photo-captain',
    data(){
        return{
            idModalL:'upLoading',
            modalLoadTitle:'Subiendo...',
            sendRequest:true,
            title:'Fotografias Capitanias',
            hasImage:false,
            scaleImage:0.85,
            qualityImage:0.9,
            captain_photo:{
                id:'',
                image:null
            },
            selectedBoat: {
                id_boat:0,
                name_boat:null,
                enrollment:null,
                enrollment_old:null,
                detail_boat:null,
                detail_propulsion:null,
                trb:null,
                trn:null,
                factor_propulsion:null,
                flag:null,
                flag_boat:null
            },
            optionSearch:'name',
            boatsEnrollment: [],
            query:'',
            dSelect:false,
            ports:[],
            port_select:{id:0, name_port:null},
            detail_photo:{title:null, description:null},
            port_low_select:{id:0, name_port:null},
            bImages:[]
        }
    },
    mounted(){
        $('.carousel').carousel({
            pause:true
        });
        this.callCaptains();
    },
    methods:{
        mChangeCaptain(){
            this.bImages=[];
        },
        setImage(output){
            this.hasImage=true;
            this.captain_photo.image=output.dataUrl;
            
            // console.log(this.ship.image);
        },
        async mLowPhoto(iphoto){
            if(iphoto.id!==0){
            // enviamos al servidor la peticion de dar de baja a la fotografia
                let message = {
                        title: 'Baja Fotografia',
                        body: `¿Desea dar de Baja a la Fotografia ${iphoto.title}?`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            this.mShowModalUP(this.idModalL);
                            try {
                                let d_photo=await axios.get(`downPhotoCaptain/${iphoto.id}?api_token=${Vue.auth.getToken()}`);

                                console.log(d_photo);
                                if(d_photo.data[0].status){
                                    toastr.success(d_photo.data[0].respuesta, 'Exito');
                                }else{
                                    toastr.error(d_photo.data[0].respuesta, 'Error');
                                }

                            } catch (error) {
                                console.log(error)   
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                    this.mCloseModalUP(this.idModalL);                                
                                }, 3000)
                            }
                            this.mGetPhotos();
                            setTimeout(()=>{                
                                this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })                  
            }else{
                console.log('este archivo no puede ser dado de baja')
            }
        },
        mValidateFormImage(){
            let ce=0;
            
            if(this.cSessionUser.roleAssign !== 'OPERADOR CAPITANIA'){
                if(this.port_select.id===0){
                toastr.warning('Seleccione una Capitania', 'Capitania');
                return false;
            }
            }else{
                this.port_select.id=this.cSessionUser.portId;
                this.port_select.name_port=this.cSessionUser.name_port;
            }

            if( !(this.detail_photo.title !== null && this.detail_photo.title !== '') ){
                toastr.warning('Indique un Titulo para la Imagen', 'Advertencia');
                ce=+1;                
            }

            if( !(this.detail_photo.description !== null && this.detail_photo.description !== '') ){
                toastr.warning('Indique una Descripcion para la Imagen', 'Advertencia');
                ce=+1;
            }

            if(ce===0){
                return true;
            }else{
                return false;
            }
        },
        sendPhotoShip(){
            if(this.mValidateFormImage()){
                // colocamamos el mensaje de que si queremos subir la fotografia
                let message = {
                        title: 'Cargar Fotografia',
                        body: `¿Desea Añadir la Fotografia a la Capitania de ${this.port_select.name_port}?`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            this.mShowModalUP(this.idModalL);
                            try {                                
                                let sa={
                                    id_port:this.port_select.id,
                                    image:this.captain_photo.image,
                                    title:this.detail_photo.title,
                                    description:this.detail_photo.description
                                }
                                    // let fu= await axios.post(`upPhotoShip`, qs.stringify(sa));
                                let fu= await axios.post(`upPhotoCaptain?api_token=${Vue.auth.getToken()}`, qs.stringify(sa));
                                    
                                if(fu.data[0].status){
                                    toastr.success(fu.data[0].respuesta, 'Exito');
                                }else{
                                    toastr.error(fu.data[0].respuesta, 'Error');
                                }

                                this.captain_photo.image=null;
                                this.hasImage=false;
                                document.getElementsByClassName('img-preview')[0].src="";
                                this.detail_photo.title=null;
                                this.detail_photo.description=null;                            

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                    this.mCloseModalUP(this.idModalL);                                
                                }, 3000)
                            }

                            setTimeout(()=>{                
                                        this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })
            }else{
                console.log('no se enviara la imagen')
            }                
        },
        mViewSearch(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            //console.log(radioV);
            this.optionSearch=radioV;
        },
        mSelectedBoat(data){
            
            this.selectedBoat=data;
            this.dSelect=true;
            // console.log(this.selectedBoat);
        },
        async callCaptains(){
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            this.ports=cp.data;
        },
        async mGetPhotos() {
            if(this.cSessionUser.roleAssign !== 'OPERADOR CAPITANIA'){
                if(this.port_low_select.id===0){
                toastr.warning('Seleccione una Capitania', 'Capitania');
                return false;
            }
            }else{
                this.port_low_select.id=this.cSessionUser.portId;
                this.port_low_select.name_port=this.cSessionUser.name_port;
            }
            // obtenemos las fotografias del 
            try {
                this.bImages = [];
                let ext;
                // let photo = await axios.get(
                // `getPhotos/${id}/N`
                // );

                let photo = await axios.get(`getPhotosCaptain/${this.port_low_select.id}?api_token=${Vue.auth.getToken()}`);

                photo.data.forEach(e => {
                    switch (e.extention) {
                        case "jpg":
                        ext = "jpeg";
                        break;

                        case "png":
                        ext = "png";
                        break;
                    }

                    let ap = {
                        id: e.id_photo,
                        path: `data:image/${ext};base64,${e.path}`,
                        title: e.title,
                        description:e.description
                    };
                    this.bImages.push(ap);
                    });

                    // this.bImages = this.bImages.find(e => {
                    // return e.image_principal === 1;
                    // });
                
            } catch (error) {
                console.error(error);
            }
        },
        mShowModalUP(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalUP(idM){
            $('#'+idM).modal('hide');
        }
    },
    computed:{
        btnUp(){
            if(this.captain_photo.image !== null)
                return true;
            else
                return false;
        },
        viewSearch(){
            switch(this.optionSearch){
                case 'name':
                    this.vSearch=true;
                break;

                case 'enrollment':
                    this.vSearch=false;
                break;
            }
            return this.vSearch;
        },
        cSessionUser(){
            return this.$store.getters.getUserState;
        }
    },
    watch:{
        query(newQuery) {
            
            axios.get(`searchShipPhotoWeb/${this.optionSearch}/${newQuery}/${this.cSessionUser.portId}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    
                    this.boatsEnrollment = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })               
        }
    },
    components:{
        'modal-loading':modalLoading
    }
}
</script>

<style>
#imageShip img{
    width: 250px;
}

#fileInput {
  display: none;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.my-8 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}

</style>



// WEBPACK FOOTER //
// src/components/captain/UploadPhotoCaptain.vue